import styled from 'styled-components';

export const TicketChatConteiner = styled.div`
  padding-top: 65px;
`;

export const MainTicketChatConteiner = styled.div`
  display: flex;
`;
